/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-fill-blanks-date',
  templateUrl: './widget-layers-fill-blanks-date.component.html',
  styleUrls: ['./widget-layers-fill-blanks-date.component.css']
})
export class WidgetLayersFillBlanksDateComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(fillBlanks: boolean) {
    this.widgetLayers.layer(this.current).change({ fillBlanks: fillBlanks });
  }

}